import { createAction, handleActions } from 'redux-actions';

import { fromJS } from 'immutable';
import { pender } from 'redux-pender';

//------------------------------------------------------
//api
//------------------------------------------------------
import * as api from 'store/actions/DataApi';

//------------------------------------------------------
//action type
//------------------------------------------------------
const SET_MY_PUBLIC_ADDRESS = 'SET_MY_PUBLIC_ADDRESS';

const POST_YOUTUBE_DETAIL = 'POST_YOUTUBE_DETAIL';


//------------------------------------------------------
// action creators
//------------------------------------------------------
export const setMyPublicAddress = createAction(SET_MY_PUBLIC_ADDRESS);

export const postYoutubeDetail = createAction(POST_YOUTUBE_DETAIL,api.postYoutubeDetail);

//------------------------------------------------------
// initial state
//------------------------------------------------------
const initialState = fromJS({
    myPublicAddress:"",
    myYoutbeData: undefined
});

//------------------------------------------------------
// reducer
//------------------------------------------------------
export default handleActions({
    [setMyPublicAddress] : (state, action) => {
        let data = action.payload;
        return state.set('myPublicAddress', data.data);
    },

    ...pender({
        type : POST_YOUTUBE_DETAIL,
        onSuccess : (state, action) => {


            const {data} = action.payload;
            console.log("dkdkddata = " ,data )

            if(data == undefined || data.length==0) return state;

            return state.set('myYoutbeData', data[0]);

            // let playGameList = state.get('playGameList') ? state.get('playGameList') : [];
            //
            // return state.set('playGameList', playGameList.concat(data.data));
        },
    }),



}, initialState)